/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PostOnetimeCodeRequestBodyTypename = "PostOnetimeCodeRequestBody" as const;

/**
 *
 * @export
 * @interface PostOnetimeCodeRequestBody
 */
export interface PostOnetimeCodeRequestBody {
  /**
   *
   * @type {number}
   * @memberof PostOnetimeCodeRequestBody
   */
  familyAccountId?: number;
  /**
   * Resource type name
   * @type {string}
   * @memberof PostOnetimeCodeRequestBody
   */
  readonly __typename?: string;
}

export function PostOnetimeCodeRequestBodyFromJSON(json: any): PostOnetimeCodeRequestBody {
  return PostOnetimeCodeRequestBodyFromJSONTyped(json, false);
}

export function PostOnetimeCodeRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PostOnetimeCodeRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PostOnetimeCodeRequestBodyTypename,

    familyAccountId: !exists(json, "family_account_id") ? undefined : json["family_account_id"],
  };
}

export function PostOnetimeCodeRequestBodyToJSON(object?: PostOnetimeCodeRequestBody | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    family_account_id: value.familyAccountId,
  };
}
